import { withNamespaces } from "react-i18next";
import { Button } from "reactstrap";

const AFTER_ASSESSMENT_STEPS = [
    "Risks evaluated",
    "Approvals generated",
    "Approvers assigned",
];

const EmptyState = ({ t, onStartAssessment }) => {
    return (
        <div className="text-center py-5">
            <h5 className="mb-2">{t("No Approval Requirements")}</h5>
            <p className="text-muted mb-4">
                {t(
                    "Complete the assessment to activate the required approvals for this asset."
                )}
            </p>
            <div className="mb-4">
                <Button type="button" color="primary" onClick={onStartAssessment}>
                    {t("Start Assessment")}
                </Button>
            </div>
            <div className="d-flex justify-content-center">
                <div className="border rounded-3 px-4 py-3 text-start">
                    <div className="text-muted font-size-13 fw-semibold mb-2">
                        {t("What happens after the assessment?")}
                    </div>
                    <div className="d-inline-flex align-items-center flex-wrap text-muted font-size-13">
                        {AFTER_ASSESSMENT_STEPS.map((step, index) => (
                            <span
                                key={step}
                                className="d-inline-flex align-items-center"
                            >
                                <span
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light text-muted font-size-11 fw-medium me-1"
                                    style={{ width: 20, height: 20 }}
                                    aria-hidden="true"
                                >
                                    {index + 1}
                                </span>
                                {t(step)}
                                {index < AFTER_ASSESSMENT_STEPS.length - 1 ? (
                                    <span className="mx-2">→</span>
                                ) : null}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withNamespaces()(EmptyState);
